const regimeTributario = {
  NENHUM: 'Nenhum',
  SIMPLES_NACIONAL: 'Simples Nacional',
  SIMPLES_NACIONAL_EXCESSO: 'Simples Nacional - Excesso',
  NORMAL_LUCRO_PRESUMIDO: 'Normal - Lucro Presumido',
  NORMAL_LUCRO_REAL: 'Normal - Lucro Real',
};

export default regimeTributario;
